import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import DOMPurify from 'dompurify';
import { isEmpty } from 'lodash';

import { CHATBOT_STATUSES } from 'pages/Students/Assignments/Overview/constants';
import { renderMarkupWithMath } from 'utils/latexRenderer';

import Typography from 'components/Typography';

import { ReactComponent as QueryIcon } from './assets/replyIcon.svg';
import styles from './styles.module.scss';

const statusesWithLoading = [
  CHATBOT_STATUSES.LOADING,
  CHATBOT_STATUSES.EXTRACTING_INSIGHTS,
  CHATBOT_STATUSES.WAITING_FOR_INITIAL_MESSAGE
];

const AssignmentChatBotReply = ({
  message = { text: '' },
  status,
  hideLoader,
  isLoading = false,
  isError = false,
  hideLoadingText = false
}) => {
  const showLoading =
    (isLoading || statusesWithLoading.includes(status)) && !hideLoader;
  const showAsError = isError || message.text === 'Uh Oh! Something went wrong';

  if (isEmpty(message.text) && !showLoading) return;

  return (
    <div className={styles.messageContainer}>
      <div className={styles.replyContainer}>
        <div className={styles.icon}>
          <QueryIcon />
        </div>

        {!hideLoadingText && statusesWithLoading.includes(status) && (
          <Typography variant="B-Text-3" className={styles.preparingText}>
            I’m getting your first question options ready…
          </Typography>
        )}
        {showLoading && <CircularProgress size={18} />}

        {!showLoading && showAsError && (
          <Typography
            variant="B-Text-3"
            component="div"
            className={styles.errorText}
          >
            {message.text || 'Something went wrong.'}
          </Typography>
        )}

        {!showLoading && !showAsError && !isEmpty(message.text) && (
          <Typography
            variant="B-Text-3"
            component="div"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                renderMarkupWithMath({ text: message.text })
              )
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AssignmentChatBotReply;
